// Tiny path router. Three routes is not worth a dependency.
import { useEffect, useState } from "react";

export function usePath() {
  const [path, setPath] = useState(window.location.pathname);
  useEffect(() => {
    const onPop = () => setPath(window.location.pathname);
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);
  return path;
}

export function navigate(to) {
  window.history.pushState({}, "", to);
  window.dispatchEvent(new PopStateEvent("popstate"));
}

/** onClick for an in-app link: a plain click stays in the app, a Cmd/Ctrl/Shift or middle click opens a tab as usual. */
export const followLink = (to) => (e) => {
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
  e.preventDefault(); navigate(to);
};

const KEY = "foodshow.inviteKey";
// The invite key must survive the MSAL redirect round-trip, so it lives in sessionStorage.
export function rememberInviteKey(key) { try { sessionStorage.setItem(KEY, key); } catch { /* private mode */ } }
export function storedInviteKey() { try { return sessionStorage.getItem(KEY); } catch { return null; } }
export function forgetInviteKey() { try { sessionStorage.removeItem(KEY); } catch { /* ignore */ } }
